import { HtmlAgenda } from "Features/Meetings/HtmlAgenda";
import { Routes } from "./RouteNames";
import { IRouteConfigMap, IRouteMap, RouteConfig } from "./RouteTypes";
import { Meetings } from "Features/Meetings";
import { PublicNotices } from "Features/PublicNotices";
import { AddCommitteeApplication, Committees, ViewCommittee } from "Features/Committees";
import { OpenPositions } from "Features/OpenPositions";

export const ROUTE_MAP: IRouteMap = {};

export const ROUTES: IRouteConfigMap = {
  [Routes.Committees]: new RouteConfig(
    Routes.Committees,
    Committees,
    "Committees",
    undefined,
    false
  ),
  [Routes.CommitteesView]: new RouteConfig(
    `${Routes.CommitteesView}/:id?`,
    ViewCommittee,
    "Committee",
    undefined,
    false
  ),
  [Routes.OpenCommitteesView]: new RouteConfig(
    `${Routes.OpenCommitteesView}/:id?`,
    ViewCommittee,
    "Committee",
    undefined,
    false
  ),
  [Routes.CommitteeApplication]: new RouteConfig(
    `${Routes.CommitteeApplication}/:id?`,
    AddCommitteeApplication,
    "Committee Application",
    undefined,
    false
  ),
  [Routes.Meetings]: new RouteConfig(
    Routes.Meetings,
    Meetings,
    "Meetings",
    undefined,
    false
  ),
  [Routes.HtmlAgenda]: new RouteConfig(
    `${Routes.HtmlAgenda}/:id?`,
    HtmlAgenda,
    "HTML Agenda",
    undefined,
    false
  ),
  [Routes.PublicNotices]: new RouteConfig(
    Routes.PublicNotices,
    PublicNotices,
    "Public Notices",
    undefined,
    false
  ),
  [Routes.OpenPositions]: new RouteConfig(
    Routes.OpenPositions,
    OpenPositions,
    "Open Positions",
    undefined,
    false
  ),
};
